(function () {
  if (window.__theRootsLandingInitialized) return;
  window.__theRootsLandingInitialized = true;

const body = document.body;
const menu = document.querySelector('.menu');
const menuOpen = document.querySelector('.js-menu-open');
const menuClose = document.querySelector('.js-menu-close');
const cart = document.querySelector('.cart');
const cartPanel = cart?.querySelector('.cart__panel');
const rootsCartViews = [...document.querySelectorAll('[data-roots-cart-view]')];
const rootsCartTitle = document.querySelector('[data-roots-cart-title]');
const rootsCartCount = document.querySelector('[data-roots-cart-count]');
const rootsCartBackButton = document.querySelector('[data-roots-cart-back]');
const rootsModal = document.querySelector('[data-roots-modal]');
const rootsModalCloseButtons = [...document.querySelectorAll('[data-roots-modal-close]')];
const rootsCheckoutButton = document.querySelector('[data-roots-checkout-open]');
const rootsForm = document.querySelector('[data-roots-form]');
const rootsEmailInput = rootsForm?.querySelector('input[type="email"]');
const rootsProjectInput = rootsForm?.querySelector('input[name="project"]');
const rootsKitsInput = rootsForm?.querySelector('input[name="kits"]');
const rootsContinueButton = rootsForm?.querySelector('[data-roots-continue]');
const rootsSubmitButton = rootsModal?.querySelector('[data-roots-submit]');
const rootsError = rootsForm?.querySelector('[data-roots-error]');
const rootsOfferPanel = document.querySelector('[data-roots-offer]');
const rootsSuccessPanel = document.querySelector('[data-roots-success]');
let rootsSubmitting = false;
const rootsContactEmails = new Set();
const cartOpenButtons = [...document.querySelectorAll('.js-cart-open')];
const cartCloseButtons = [...document.querySelectorAll('.js-cart-close')];
let menuTrigger = null;
let cartTrigger = null;

const setViewportHeight = () => {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

setViewportHeight();
window.addEventListener('resize', setViewportHeight);

const setMenu = (open) => {
  if (open) menuTrigger = document.activeElement;
  menu?.classList.toggle('menu--open', open);
  menu?.setAttribute('aria-hidden', String(!open));
  menuOpen?.setAttribute('aria-expanded', String(open));
  menuOpen?.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  body.classList.toggle('menu-open', open);
  if (open) {
    setTimeout(() => menuClose?.focus(), 0);
  } else if (menuTrigger instanceof HTMLElement) {
    menuTrigger.focus();
  }
};

menuOpen?.addEventListener('click', () => {
  setMenu(!menu?.classList.contains('menu--open'));
});
menuClose?.addEventListener('click', () => setMenu(false));
menu?.addEventListener('click', (event) => {
  if (event.target === menu) setMenu(false);
});
menu?.querySelectorAll('.menu__link, .menu__logo').forEach((link) => {
  link.addEventListener('click', () => setMenu(false));
});

const setCart = (open) => {
  if (open) {
    cartTrigger = document.activeElement;
    if (menu?.classList.contains('menu--open')) setMenu(false);
  }

  cart?.classList.toggle('cart--open', open);
  cart?.setAttribute('aria-hidden', String(!open));
  cartOpenButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
  body.classList.toggle('cart-open', open);

  if (open) {
    showRootsCartView('cart');
    setTimeout(() => cart?.querySelector('.js-cart-close')?.focus({ preventScroll: true }), 0);
  } else {
    setRootsModal(false);
    if (cartTrigger instanceof HTMLElement) cartTrigger.focus({ preventScroll: true });
  }
};

cartCloseButtons.forEach((button) => {
  button.addEventListener('click', () => setCart(false));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (rootsModal?.classList.contains('roots-modal--open')) {
    setRootsModal(false);
    return;
  }
  setMenu(false);
  setCart(false);
});

const productGallery = document.querySelector('.product-gallery');
const productGalleryMain = productGallery?.querySelector('.product-gallery__main');
const productGalleryWrapper = productGalleryMain?.querySelector('.swiper-wrapper');
const productThumbsContainer = productGallery?.querySelector('.product-gallery__thumbs');
const productPagination = productGallery?.querySelector('.product-gallery__pagination');
const productCollectionSlideTemplate = productGallery?.querySelector('[data-product-collection-slide-template]');
const productCollectionThumbTemplate = productGallery?.querySelector('[data-product-collection-thumb-template]');
const productCollectionBarTemplate = productGallery?.querySelector('[data-product-collection-bar-template]');
let productPictures = [];
let productThumbs = [];
let productBars = [];
let productSlide = 0;
let productGallerySwiper = null;

const refreshProductGalleryItems = () => {
  productPictures = [...(productGallery?.querySelectorAll('.js-product-picture') ?? [])];
  productThumbs = [...(productGallery?.querySelectorAll('.product-gallery__thumb') ?? [])];
  productBars = [...(productGallery?.querySelectorAll('.js-product-bar') ?? [])];
  productBars.forEach((bar, index) => {
    bar.setAttribute('aria-label', `Show product image ${index + 1}`);
  });
};

refreshProductGalleryItems();

const syncProductSlide = (index) => {
  if (!productPictures.length || !productThumbs.length) return;
  productSlide = (index + productThumbs.length) % productThumbs.length;

  productPictures.forEach((picture, pictureIndex) => {
    picture.classList.toggle('product-gallery__picture--active', pictureIndex === productSlide);
  });
  productThumbs.forEach((thumb, thumbIndex) => {
    const active = thumbIndex === productSlide;
    thumb.classList.toggle('product-gallery__thumb--active', active);
    if (active) {
      thumb.setAttribute('aria-current', 'true');
      if (productThumbsContainer?.scrollHeight > productThumbsContainer.clientHeight) {
        const thumbTop = thumb.offsetTop;
        const thumbBottom = thumbTop + thumb.offsetHeight;
        const visibleTop = productThumbsContainer.scrollTop;
        const visibleBottom = visibleTop + productThumbsContainer.clientHeight;

        if (thumbTop < visibleTop) {
          productThumbsContainer.scrollTo({ top: thumbTop, behavior: 'smooth' });
        } else if (thumbBottom > visibleBottom) {
          productThumbsContainer.scrollTo({
            top: thumbBottom - productThumbsContainer.clientHeight,
            behavior: 'smooth',
          });
        }
      }
    } else {
      thumb.removeAttribute('aria-current');
    }
  });
  productBars.forEach((bar, barIndex) => {
    const active = barIndex === productSlide;
    bar.classList.toggle('product-gallery__bar--active', active);
    if (active) {
      bar.setAttribute('aria-current', 'true');
    } else {
      bar.removeAttribute('aria-current');
    }
  });
};

const setProductSlide = (index) => {
  const nextSlide = productThumbs.length ? (index + productThumbs.length) % productThumbs.length : index;

  if (productGallerySwiper) {
    productGallerySwiper.slideTo(nextSlide);
    syncProductSlide(nextSlide);
    return;
  }

  syncProductSlide(nextSlide);
};

if (productGalleryMain && typeof window.Swiper === 'function') {
  productGallerySwiper = new window.Swiper(productGalleryMain, {
    slidesPerView: 1,
    speed: 450,
    grabCursor: true,
    rewind: true,
    navigation: {
      prevEl: productGallery.querySelector('.js-product-prev'),
      nextEl: productGallery.querySelector('.js-product-next'),
    },
    on: {
      init(swiper) {
        syncProductSlide(swiper.activeIndex);
      },
      slideChange(swiper) {
        syncProductSlide(swiper.activeIndex);
      },
    },
  });
} else {
  syncProductSlide(productSlide);

  productGallery?.querySelector('.js-product-prev')?.addEventListener('click', () => {
    setProductSlide(productSlide - 1);
  });
  productGallery?.querySelector('.js-product-next')?.addEventListener('click', () => {
    setProductSlide(productSlide + 1);
  });
}

productGallery?.addEventListener('click', (event) => {
  const thumb = event.target.closest('.product-gallery__thumb');
  if (thumb) {
    setProductSlide(productThumbs.indexOf(thumb));
    return;
  }

  const bar = event.target.closest('.js-product-bar');
  if (bar) setProductSlide(productBars.indexOf(bar));
});

const insideSticky = document.querySelector('[data-inside-sticky]');
const insideContents = [...(insideSticky?.querySelectorAll('.inside__row-content') ?? [])];
const insideImages = [...(insideSticky?.querySelectorAll('.inside__row-images .inside__row-image') ?? [])];
const insideDesktopQuery = window.matchMedia('(min-width: 1025px)');
let insideRaf = null;

const syncInsideSticky = () => {
  insideRaf = null;

  if (!insideContents.length || !insideImages.length) return;

  let activeIndex = 0;

  if (insideDesktopQuery.matches) {
    const sectionRect = insideSticky.getBoundingClientRect();

    if (sectionRect.bottom <= 0) {
      activeIndex = insideImages.length - 1;
    } else if (sectionRect.top < window.innerHeight) {
      const targetY = window.innerHeight * 0.5;
      let closestDistance = Number.POSITIVE_INFINITY;

      insideContents.forEach((content, index) => {
        const rect = content.getBoundingClientRect();
        const centerY = rect.top + rect.height * 0.5;
        const distance = Math.abs(centerY - targetY);

        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });
    }
  }

  insideImages.forEach((image, index) => {
    image.classList.toggle('inside__row-image--active', index === activeIndex);
  });
};

const requestInsideSync = () => {
  if (insideRaf !== null) return;
  insideRaf = window.requestAnimationFrame(syncInsideSticky);
};

if (insideContents.length && insideImages.length) {
  syncInsideSticky();
  window.addEventListener('scroll', requestInsideSync, { passive: true });
  window.addEventListener('resize', requestInsideSync);
  insideDesktopQuery.addEventListener?.('change', requestInsideSync);
}

let quantity = 1;
let renderCollectionSummary = () => {};
const quantityInput = document.querySelector('.js-quantity');
const renderQuantity = () => {
  if (quantityInput) quantityInput.value = quantity;
  renderCollectionSummary();
};
document.querySelector('.js-minus')?.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); renderQuantity(); });
document.querySelector('.js-plus')?.addEventListener('click', () => { quantity += 1; renderQuantity(); });
quantityInput?.addEventListener('change', () => {
  quantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
  renderQuantity();
});

const productSection = document.querySelector('.section--product');
const productVariants = document.querySelector('.product__variants');
const productVariantButtons = [...document.querySelectorAll('.product__variant[data-product-variant]')];
const collectionControls = document.querySelectorAll('.product__collection-control');
const collectionTooltipButtons = [...document.querySelectorAll('.product__collection-item-help')];
const collectionAddTexts = document.querySelectorAll('.product__collection-add-text--mob');
const totalCount = document.querySelector('.js-total-count');
const totalOld = document.querySelector('.js-total-old');
const totalCurrent = document.querySelector('.js-total-current');
const productVariantPrices = {
  book: {
    current: 99,
  },
  collection: {
    current: 198,
    old: 248,
  },
};
const collectionKitPrice = 29;
const collectionFirstKitPrice = 17;
let selectedProductVariant = productVariantButtons.find((button) => (
  button.classList.contains('product__variant--active')
))?.dataset.productVariant || 'book';
let selectedKitNames = [];
let activeCollectionTooltip = null;

const positionCollectionTooltip = (button) => {
  const tooltip = button.querySelector('.product__collection-item-tooltip');
  const info = button.closest('.product__info');
  if (!tooltip || !info) return;

  const buttonRect = button.getBoundingClientRect();
  const infoRect = info.getBoundingClientRect();
  const tooltipRect = tooltip.getBoundingClientRect();
  const gutter = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
  const centeredLeft = infoRect.left + (infoRect.width - tooltipRect.width) / 2;
  const left = Math.max(
    gutter,
    Math.min(centeredLeft, document.documentElement.clientWidth - gutter - tooltipRect.width),
  );

  tooltip.style.left = `${left - buttonRect.left}px`;
};

const closeCollectionTooltip = () => {
  activeCollectionTooltip?.classList.remove('product__collection-item-help--open');
  activeCollectionTooltip?.setAttribute('aria-expanded', 'false');
  activeCollectionTooltip = null;
};

const openCollectionTooltip = (button) => {
  if (activeCollectionTooltip !== button) closeCollectionTooltip();
  positionCollectionTooltip(button);
  button.classList.add('product__collection-item-help--open');
  button.setAttribute('aria-expanded', 'true');
  activeCollectionTooltip = button;
};

collectionTooltipButtons.forEach((button) => {
  let pointerType = 'mouse';
  button.setAttribute('aria-expanded', 'false');

  button.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse') openCollectionTooltip(button);
  });
  button.addEventListener('pointerleave', (event) => {
    if (event.pointerType === 'mouse' && !button.matches(':focus-visible') && activeCollectionTooltip === button) {
      closeCollectionTooltip();
    }
  });
  button.addEventListener('pointerdown', (event) => {
    pointerType = event.pointerType;
  });
  button.addEventListener('focus', () => {
    if (button.matches(':focus-visible')) openCollectionTooltip(button);
  });
  button.addEventListener('blur', () => {
    if (!button.matches(':hover') && activeCollectionTooltip === button) closeCollectionTooltip();
  });
  button.addEventListener('click', (event) => {
    const touchClick = event.detail !== 0 && (pointerType === 'touch' || pointerType === 'pen');
    if (touchClick && activeCollectionTooltip === button) {
      closeCollectionTooltip();
    } else {
      openCollectionTooltip(button);
    }
  });
});

document.addEventListener('pointerdown', (event) => {
  if (activeCollectionTooltip && !activeCollectionTooltip.contains(event.target)) closeCollectionTooltip();
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeCollectionTooltip();
});
window.addEventListener('resize', () => {
  if (activeCollectionTooltip) positionCollectionTooltip(activeCollectionTooltip);
});

if (typeof window.ResizeObserver === 'function') {
  const collectionTooltipResizeObserver = new window.ResizeObserver(() => {
    if (activeCollectionTooltip) positionCollectionTooltip(activeCollectionTooltip);
  });
  document.querySelectorAll('.product__info').forEach((info) => {
    collectionTooltipResizeObserver.observe(info);
  });
}

const syncProductVariantIndicator = () => {
  const activeVariant = productVariantButtons.find((button) => (
    button.classList.contains('product__variant--active')
  ));
  if (!productVariants || !activeVariant) return;

  productVariants.style.setProperty('--product-variant-indicator-x', `${activeVariant.offsetLeft}px`);
  productVariants.style.setProperty('--product-variant-indicator-width', `${activeVariant.offsetWidth}px`);
  window.requestAnimationFrame(() => {
    productVariants.classList.add('product__variants--indicator-ready');
  });
};

const syncProductVariantMedia = (variant) => {
  const isCollection = variant === 'collection';
  const collectionSlide = productGallery?.querySelector('[data-product-collection-slide]');
  const collectionThumb = productGallery?.querySelector('[data-product-collection-thumb]');
  const collectionBar = productGallery?.querySelector('[data-product-collection-bar]');

  if (isCollection && !collectionSlide) {
    const slide = productCollectionSlideTemplate?.content.firstElementChild?.cloneNode(true);
    const thumb = productCollectionThumbTemplate?.content.firstElementChild?.cloneNode(true);
    const bar = productCollectionBarTemplate?.content.firstElementChild?.cloneNode(true);
    if (slide) productGalleryWrapper?.prepend(slide);
    if (thumb) productThumbsContainer?.prepend(thumb);
    if (bar) productPagination?.prepend(bar);
  } else if (!isCollection) {
    collectionSlide?.remove();
    collectionThumb?.remove();
    collectionBar?.remove();
  }

  refreshProductGalleryItems();
  productGallerySwiper?.update();
};

const getCollectionQuantity = () => [...collectionControls].reduce((total, control) => {
  const input = control.querySelector('.js-collection-input');
  return total + Math.max(0, Number.parseInt(input?.value, 10) || 0);
}, 0);

const formatPrice = (value) => `$${value.toFixed(2).replace('.', ',')}`;
const formatCartPrice = (value, options = {}) => {
  const prefix = options.compact ? '$' : '$ ';
  const amount = value.toFixed(2).replace('.', ',');
  return `${prefix}${amount}`;
};

const getCollectionKitName = (control) => (
  control.dataset.kitName
  || control.closest('.product__collection-item')?.querySelector('.product__collection-title')?.textContent.trim()
  || ''
);

const getSelectedCollectionKits = () => [...collectionControls].reduce((kits, control) => {
  const input = control.querySelector('.js-collection-input');
  const quantityValue = Math.max(0, Number.parseInt(input?.value, 10) || 0);
  const kitName = getCollectionKitName(control);

  if (!quantityValue || !kitName) return kits;

  kits.push(quantityValue > 1 ? `${kitName} x${quantityValue}` : kitName);
  return kits;
}, []);

const syncRootsFormPayload = () => {
  if (!rootsForm) return selectedKitNames;

  const project = rootsProjectInput?.value.trim();
  if (project) {
    const formProjectInput = rootsForm.querySelector('input[name="project"]');
    if (formProjectInput) formProjectInput.value = project;
  }

  const kitNames = selectedKitNames.filter(Boolean);
  const collectionCartItem = document.querySelector('[data-cart-product="collection"]');
  if (collectionCartItem && !collectionCartItem.classList.contains('cart__product--hidden')) {
    kitNames.push('The Roots Apothecary Collection');
  }

  const uniqueKitNames = [...new Set(kitNames)];
  if (rootsKitsInput) rootsKitsInput.value = uniqueKitNames.join(', ');

  return uniqueKitNames;
};

renderCollectionSummary = () => {
  const collectionQuantity = getCollectionQuantity();
  const nextKitPrice = collectionQuantity > 0 ? collectionKitPrice : collectionFirstKitPrice;
  let itemCount = quantity * (1 + collectionQuantity);
  let originalPrice = quantity * (
    productVariantPrices.book.current + (collectionQuantity * collectionKitPrice)
  );
  let currentPrice = collectionQuantity > 0 ? Math.ceil(originalPrice * 0.9) : originalPrice;

  if (selectedProductVariant === 'collection') {
    itemCount = quantity;
    originalPrice = quantity * productVariantPrices.collection.old;
    currentPrice = quantity * productVariantPrices.collection.current;
  }

  if (totalCount) totalCount.textContent = `(${itemCount} ${itemCount === 1 ? 'item' : 'items'})`;
  if (totalOld) {
    totalOld.textContent = formatPrice(originalPrice);
    totalOld.hidden = currentPrice >= originalPrice;
  }
  if (totalCurrent) totalCurrent.textContent = formatPrice(currentPrice);
  collectionAddTexts.forEach((label) => {
    label.textContent = `ADD FOR ${formatPrice(nextKitPrice)}`;
  });
};

const setProductVariant = (variant) => {
  selectedProductVariant = variant === 'collection' ? 'collection' : 'book';
  productSection?.setAttribute('data-product-variant', selectedProductVariant);
  syncProductVariantMedia(selectedProductVariant);
  setProductSlide(0);

  productVariantButtons.forEach((button) => {
    const isActive = button.dataset.productVariant === selectedProductVariant;
    button.classList.toggle('product__variant--active', isActive);
    button.setAttribute('aria-pressed', String(isActive));
  });

  syncProductVariantIndicator();
  renderCollectionSummary();
};

productVariantButtons.forEach((button) => {
  button.addEventListener('click', () => {
    setProductVariant(button.dataset.productVariant);
  });
});

const setCollectionQuantity = (control, value) => {
  const input = control.querySelector('.js-collection-input');
  const nextValue = Math.max(0, value);
  if (input) input.value = nextValue;
  control.classList.toggle('product__collection-control--active', nextValue > 0);
  renderCollectionSummary();
};

collectionControls.forEach((control) => {
  const input = control.querySelector('.js-collection-input');
  const getValue = () => Math.max(0, Number.parseInt(input?.value, 10) || 0);

  control.querySelector('.js-collection-add')?.addEventListener('click', () => {
    setCollectionQuantity(control, 1);
  });
  control.querySelector('.js-collection-minus')?.addEventListener('click', () => {
    setCollectionQuantity(control, getValue() - 1);
  });
  control.querySelector('.js-collection-plus')?.addEventListener('click', () => {
    setCollectionQuantity(control, getValue() + 1);
  });
  input?.addEventListener('change', () => {
    setCollectionQuantity(control, getValue());
  });
});

renderCollectionSummary();
setProductVariant(selectedProductVariant);

if (productVariants && typeof window.ResizeObserver === 'function') {
  const productVariantResizeObserver = new window.ResizeObserver(syncProductVariantIndicator);
  productVariantResizeObserver.observe(productVariants);
  productVariantButtons.forEach((button) => productVariantResizeObserver.observe(button));
} else {
  window.addEventListener('resize', syncProductVariantIndicator);
}
document.fonts?.ready?.then(syncProductVariantIndicator);

let cartCount = 0;
const cartLabels = document.querySelectorAll('.js-cart-count');
const cartItems = [...document.querySelectorAll('.js-cart-item')];
const cartBookItem = cartItems.find((item) => item.dataset.cartProduct === 'book');
const cartCollectionItem = cartItems.find((item) => item.dataset.cartProduct === 'collection');
const cartCountLabels = document.querySelectorAll('.js-cart-count-label');
const cartEmptyMessage = document.querySelector('[data-cart-empty]');
const cartSummary = document.querySelector('[data-cart-summary]');
const cartSummaryOld = document.querySelector('[data-cart-summary-old]');
const cartSummaryCurrent = document.querySelector('[data-cart-summary-current]');
const cartSummaryDiscount = document.querySelector('[data-cart-summary-discount]');

const getCartQuantity = (item) => {
  const input = item.querySelector('.js-cart-quantity');
  return Math.max(1, Number.parseInt(input?.value, 10) || 1);
};

const getSelectedKitQuantity = () => selectedKitNames.reduce((total, name) => {
  const quantityMatch = name.match(/\s+x(\d+)$/i);
  return total + Math.max(1, Number.parseInt(quantityMatch?.[1], 10) || 1);
}, 0);

const renderCartPrices = () => {
  let subtotal = 0;
  let subtotalOld = 0;
  const lineDiscountRates = new Set();

  cartItems.forEach((item) => {
    if (item.classList.contains('cart__product--hidden')) return;

    const itemQuantity = getCartQuantity(item);
    const unitPrice = Number.parseFloat(item.dataset.cartUnitPrice || '0') || 0;
    const unitOldPrice = Number.parseFloat(item.dataset.cartUnitOldPrice || '0') || 0;
    const lineCurrent = item.querySelector('[data-cart-line-current]');
    const lineOld = item.querySelector('[data-cart-line-old]');
    let lineCurrentTotal = unitPrice * itemQuantity;
    let lineOldTotal = (unitOldPrice || unitPrice) * itemQuantity;
    let lineDiscountRate = 0;

    if (item.dataset.cartProduct === 'book') {
      const kitQuantity = getSelectedKitQuantity();
      lineOldTotal += itemQuantity * kitQuantity * collectionKitPrice;
      if (kitQuantity > 0) {
        lineCurrentTotal = Math.ceil(lineOldTotal * 0.9);
        lineDiscountRate = 10;
      } else {
        lineCurrentTotal = lineOldTotal;
      }
    } else if (lineOldTotal > lineCurrentTotal) {
      lineDiscountRate = 20;
    }

    subtotal += lineCurrentTotal;
    subtotalOld += lineOldTotal;
    lineDiscountRates.add(lineDiscountRate);

    if (lineCurrent) lineCurrent.textContent = formatCartPrice(lineCurrentTotal);
    if (lineOld) lineOld.textContent = formatCartPrice(lineOldTotal, { compact: true });
  });

  if (cartSummaryCurrent) cartSummaryCurrent.textContent = formatCartPrice(subtotal);
  if (cartSummaryOld) cartSummaryOld.textContent = subtotalOld > subtotal ? formatCartPrice(subtotalOld, { compact: true }) : '';
  if (cartSummaryDiscount) {
    let discountRate = 0;
    if (subtotalOld > subtotal) {
      discountRate = lineDiscountRates.size === 1
        ? [...lineDiscountRates][0]
        : Math.round(((subtotalOld - subtotal) / subtotalOld) * 100);
    }
    cartSummaryDiscount.textContent = `-${discountRate}%`;
    cartSummaryDiscount.hidden = subtotalOld <= subtotal;
  }
};

const renderCartCount = () => {
  cartCount = cartItems.reduce((total, item) => {
    if (item.classList.contains('cart__product--hidden')) return total;
    return total + getCartQuantity(item);
  }, 0);
  cartLabels.forEach((label) => { label.textContent = cartCount; });
  cartCountLabels.forEach((label) => { label.textContent = cartCount === 1 ? 'item' : 'items'; });
  if (cartEmptyMessage) cartEmptyMessage.hidden = cartCount > 0;
  if (cartSummary) cartSummary.hidden = cartCount === 0;
  if (rootsCheckoutButton) rootsCheckoutButton.disabled = cartCount === 0;
  renderCartPrices();
};

const setCartItemQuantity = (item, value) => {
  if (!item) return;
  const input = item.querySelector('.js-cart-quantity');
  const nextValue = Math.max(1, value);
  if (input) input.value = nextValue;
  item.classList.remove('cart__product--hidden');
  renderCartCount();
};

const addCartItem = (item, amount) => {
  if (!item) return;
  const currentQuantity = item.classList.contains('cart__product--hidden') ? 0 : getCartQuantity(item);
  setCartItemQuantity(item, currentQuantity + Math.max(1, amount));
};

const normalizeKitName = (name) => name.replace(/\s+x\d+$/i, '').trim();

const syncCartIncludedItems = (kitNames) => {
  const selectedKits = new Set(kitNames.map(normalizeKitName));

  document.querySelectorAll('.cart__included').forEach((included) => {
    let visibleItems = 0;

    included.querySelectorAll('.cart__included-item').forEach((item) => {
      const kitName = item.dataset.kitName || item.querySelector('.cart__included-title')?.textContent.trim() || '';
      const isSelected = selectedKits.has(normalizeKitName(kitName));
      item.classList.toggle('cart__included-item--hidden', !isSelected);
      if (isSelected) visibleItems += 1;
    });

    included.classList.toggle('cart__included--empty', visibleItems === 0);
  });
};

cartItems.forEach((item) => {
  const input = item.querySelector('.js-cart-quantity');
  const getValue = () => Math.max(1, Number.parseInt(input?.value, 10) || 1);

  item.querySelector('.js-cart-quantity-minus')?.addEventListener('click', () => {
    setCartItemQuantity(item, getValue() - 1);
  });
  item.querySelector('.js-cart-quantity-plus')?.addEventListener('click', () => {
    setCartItemQuantity(item, getValue() + 1);
  });
  input?.addEventListener('change', () => {
    setCartItemQuantity(item, getValue());
  });
  item.querySelector('.js-cart-remove')?.addEventListener('click', () => {
    item.classList.add('cart__product--hidden');
    if (input) input.value = 0;
    if (item.dataset.cartProduct === 'book') {
      selectedKitNames = [];
      syncCartIncludedItems(selectedKitNames);
    }
    syncRootsFormPayload();
    renderCartCount();
  });
});

document.querySelectorAll('.js-cart-included-remove').forEach((button) => {
  button.addEventListener('click', () => {
    const item = button.closest('.cart__included-item');
    const included = button.closest('.cart__included');
    const kitName = item?.dataset.kitName || item?.querySelector('.cart__included-title')?.textContent.trim();
    item?.classList.add('cart__included-item--hidden');
    if (kitName) {
      selectedKitNames = selectedKitNames.filter((name) => normalizeKitName(name) !== normalizeKitName(kitName));
      syncRootsFormPayload();
    }

    const hasIncludedItems = included?.querySelector(
      '.cart__included-item:not(.cart__included-item--hidden)',
    );
    if (!hasIncludedItems) {
      included?.classList.add('cart__included--empty');
    }
    renderCartCount();
  });
});

document.querySelector('.product__form')?.addEventListener('submit', (event) => {
  event.preventDefault();

  if (selectedProductVariant === 'collection') {
    addCartItem(cartCollectionItem, quantity);
    syncRootsFormPayload();
    setCart(true);
    return;
  }

  selectedKitNames = getSelectedCollectionKits();
  addCartItem(cartBookItem, quantity);
  syncRootsFormPayload();
  syncCartIncludedItems(selectedKitNames);
  setCart(true);
});
cartOpenButtons.forEach((button) => {
  button.addEventListener('click', () => {
    if (!button.classList.contains('header__cart')) {
      selectedKitNames = getSelectedCollectionKits();
      addCartItem(cartBookItem, 1);
      syncRootsFormPayload();
      syncCartIncludedItems(selectedKitNames);
    }
    setCart(true);
  });
});

renderCartCount();

const boxPictures = [...document.querySelectorAll('.js-box-picture')];
const boxThumbs = [...document.querySelectorAll('.js-box-thumb')];
const boxSlider = document.querySelector('.box__slider');
let boxSlide = 0;
let boxSwiper = null;

const syncBoxSlide = (index) => {
  if (!boxPictures.length || !boxThumbs.length) return;
  boxSlide = (index + boxThumbs.length) % boxThumbs.length;

  boxPictures.forEach((picture, pictureIndex) => {
    picture.classList.toggle('box__picture--active', pictureIndex === boxSlide);
  });
  boxThumbs.forEach((thumb, thumbIndex) => {
    const active = thumbIndex === boxSlide;
    thumb.classList.toggle('box__thumb--active', active);
    if (active) {
      thumb.setAttribute('aria-current', 'true');
    } else {
      thumb.removeAttribute('aria-current');
    }
  });
};

const setBoxSlide = (index) => {
  const nextSlide = boxThumbs.length ? (index + boxThumbs.length) % boxThumbs.length : index;

  if (boxSwiper) {
    boxSwiper.slideTo(nextSlide);
    return;
  }

  syncBoxSlide(nextSlide);
};

if (boxSlider && typeof window.Swiper === 'function') {
  boxSwiper = new window.Swiper(boxSlider, {
    slidesPerView: 1,
    speed: 550,
    grabCursor: true,
    rewind: true,
    navigation: {
      prevEl: document.querySelector('.js-box-prev'),
      nextEl: document.querySelector('.js-box-next'),
    },
    on: {
      init(swiper) {
        syncBoxSlide(swiper.activeIndex);
      },
      slideChange(swiper) {
        syncBoxSlide(swiper.activeIndex);
      },
    },
  });
} else {
  syncBoxSlide(boxSlide);

  document.querySelector('.js-box-prev')?.addEventListener('click', () => setBoxSlide(boxSlide - 1));
  document.querySelector('.js-box-next')?.addEventListener('click', () => setBoxSlide(boxSlide + 1));
}

boxThumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => setBoxSlide(index));
});

const boxQuantityInput = document.querySelector('.js-box-quantity');
let boxQuantity = Math.max(1, Number.parseInt(boxQuantityInput?.value, 10) || 1);

const renderBoxQuantity = () => {
  if (boxQuantityInput) boxQuantityInput.value = boxQuantity;
};

document.querySelector('.js-box-minus')?.addEventListener('click', () => {
  boxQuantity = Math.max(1, boxQuantity - 1);
  renderBoxQuantity();
});
document.querySelector('.js-box-plus')?.addEventListener('click', () => {
  boxQuantity += 1;
  renderBoxQuantity();
});
boxQuantityInput?.addEventListener('change', () => {
  boxQuantity = Math.max(1, Number.parseInt(boxQuantityInput.value, 10) || 1);
  renderBoxQuantity();
});
document.querySelector('.box__form')?.addEventListener('submit', (event) => {
  event.preventDefault();
  addCartItem(cartCollectionItem, boxQuantity);
  syncRootsFormPayload();
  setCart(true);
});

const accordionItems = [...document.querySelectorAll('.accordion__item')];

const updateOpenAccordionHeights = () => {
  accordionItems.forEach((item) => {
    if (!item.classList.contains('accordion__item--open')) return;
    const content = item.querySelector('.accordion__content');
    if (content) content.style.maxHeight = `${content.scrollHeight}px`;
  });
};

accordionItems.forEach((item) => {
  const button = item.querySelector('.accordion__button');
  const content = item.querySelector('.accordion__content');
  if (!button || !content) return;

  button.setAttribute('aria-expanded', 'false');
  content.style.maxHeight = '0px';

  button.addEventListener('click', () => {
    const open = !item.classList.contains('accordion__item--open');

    item.classList.toggle('accordion__item--open', open);
    button.setAttribute('aria-expanded', String(open));
    content.style.maxHeight = open ? `${content.scrollHeight}px` : '0px';
  });
});

const setRootsModal = (open) => {
  if (!rootsModal) return;

  const wasOpen = rootsModal.classList.contains('roots-modal--open');
  rootsModal.classList.toggle('roots-modal--open', open);
  rootsModal.setAttribute('aria-hidden', String(!open));
  body.classList.toggle('roots-modal-open', open);
  cartPanel?.toggleAttribute('inert', open);

  if (open) {
    rootsOfferPanel?.removeAttribute('hidden');
    rootsSuccessPanel?.setAttribute('hidden', '');
    rootsModal.setAttribute('aria-labelledby', 'roots-modal-title');
    if (rootsSubmitButton) {
      rootsSubmitButton.disabled = rootsSubmitting;
      rootsSubmitButton.textContent = rootsSubmitting ? 'SENDING...' : 'JOIN WAITLIST';
    }
    rootsEmailInput?.blur();
    rootsSubmitButton?.focus({ preventScroll: true });
  } else if (wasOpen && cart?.classList.contains('cart--open')) {
    rootsContinueButton?.focus({ preventScroll: true });
  }
};

const showRootsError = (message) => {
  if (!rootsError) return;

  rootsError.textContent = message;
  rootsError.hidden = false;
};

const hideRootsError = () => {
  if (!rootsError) return;

  rootsError.textContent = '';
  rootsError.hidden = true;
  rootsEmailInput?.removeAttribute('aria-invalid');
};

const validateRootsEmail = () => {
  const email = rootsEmailInput?.value.trim() || '';
  if (!email || !rootsEmailInput?.checkValidity()) {
    showRootsError('Please enter a valid email address first.');
    rootsEmailInput?.setAttribute('aria-invalid', 'true');
    rootsEmailInput?.focus({ preventScroll: true });
    return false;
  }

  hideRootsError();
  return true;
};

const showRootsSuccess = () => {
  rootsOfferPanel?.setAttribute('hidden', '');
  rootsSuccessPanel?.removeAttribute('hidden');
  rootsModal?.setAttribute('aria-labelledby', 'roots-success-title');
  if (rootsModal?.classList.contains('roots-modal--open')) {
    rootsSuccessPanel?.querySelector('[data-roots-modal-close]')?.focus({ preventScroll: true });
  }
};

const showRootsCartView = (view) => {
  const isCheckout = view === 'checkout';
  rootsCartViews.forEach((element) => { element.hidden = element.dataset.rootsCartView !== view; });
  if (rootsCartTitle) rootsCartTitle.textContent = isCheckout ? 'CHECKOUT' : 'CART';
  if (rootsCartCount) rootsCartCount.hidden = isCheckout;
  if (rootsCartBackButton) rootsCartBackButton.hidden = !isCheckout;
  hideRootsError();
  if (cartPanel) cartPanel.scrollTop = 0;
  if (isCheckout) rootsEmailInput?.focus({ preventScroll: true });
  else if (cart?.classList.contains('cart--open')) rootsCheckoutButton?.focus({ preventScroll: true });
};

rootsCheckoutButton?.addEventListener('click', () => {
  if (cartCount === 0) return;
  syncRootsFormPayload();
  showRootsCartView('checkout');
});

rootsCartBackButton?.addEventListener('click', () => showRootsCartView('cart'));

rootsModalCloseButtons.forEach((button) => {
  button.addEventListener('click', () => setRootsModal(false));
});

rootsModal?.addEventListener('keydown', (event) => {
  if (event.key !== 'Tab') return;
  const buttons = [...rootsModal.querySelectorAll('.roots-modal__panel button:not(:disabled)')]
    .filter((button) => button.getClientRects().length > 0);
  const first = buttons[0];
  const last = buttons[buttons.length - 1];
  if ((event.shiftKey && document.activeElement === first) || (!event.shiftKey && document.activeElement === last)) {
    event.preventDefault();
    (event.shiftKey ? last : first)?.focus({ preventScroll: true });
  }
});

rootsEmailInput?.addEventListener('input', hideRootsError);

const sendRootsResearch = async (projectSuffix = '') => {
  const formData = new FormData(rootsForm);
  const sourceUrl = new URL(window.location.href);
  sourceUrl.hash = '';
  formData.set('email', rootsEmailInput.value.trim());
  formData.set('project', `${rootsProjectInput?.value.trim() || 'the-roots'}${projectSuffix}`);
  formData.set('kits', syncRootsFormPayload().join(', '));
  formData.set('source_url', sourceUrl.toString());

  const response = await fetch(rootsForm.action, { method: 'POST', body: formData });
  let json = null;
  try {
    json = await response.json();
  } catch (_error) {
    json = null;
  }

  if (!response.ok || json?.success !== true) {
    throw new Error((json && json.message) || 'Failed to send. Please try again.');
  }
};

rootsForm?.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (rootsSubmitting || cartCount === 0 || !validateRootsEmail()) return;

  const email = rootsEmailInput.value.trim().toLowerCase();
  if (!rootsContactEmails.has(email)) {
    rootsSubmitting = true;
    rootsEmailInput.readOnly = true;
    if (rootsContinueButton) {
      rootsContinueButton.disabled = true;
      rootsContinueButton.textContent = 'SENDING...';
    }

    try {
      await sendRootsResearch('-email');
      rootsContactEmails.add(email);
    } catch (error) {
      showRootsError(error.message || 'Failed to send. Please try again.');
      return;
    } finally {
      rootsSubmitting = false;
      rootsEmailInput.readOnly = false;
      if (rootsContinueButton) {
        rootsContinueButton.disabled = false;
        rootsContinueButton.textContent = 'CONTINUE TO SHIPPING';
      }
    }
  }

  if (cart?.classList.contains('cart--open') && !rootsForm.hidden) setRootsModal(true);
});

rootsSubmitButton?.addEventListener('click', async () => {
  if (rootsSubmitting || !rootsForm || cartCount === 0) return;
  if (!validateRootsEmail()) {
    setRootsModal(false);
    rootsEmailInput?.focus({ preventScroll: true });
    return;
  }

  rootsSubmitting = true;
  if (rootsSubmitButton) {
    rootsSubmitButton.disabled = true;
    rootsSubmitButton.textContent = 'SENDING...';
  }

  try {
    await sendRootsResearch();
    showRootsSuccess();
  } catch (error) {
    setRootsModal(false);
    showRootsError(error.message || 'Failed to send. Please try again.');
  } finally {
    rootsSubmitting = false;
    if (rootsSubmitButton) {
      rootsSubmitButton.disabled = false;
      rootsSubmitButton.textContent = 'JOIN WAITLIST';
    }
  }
});

window.addEventListener('resize', updateOpenAccordionHeights);
document.fonts?.ready?.then(updateOpenAccordionHeights);

})();

const body = document.body;
const stickyElm = document.querySelector('.section--header');
const header = stickyElm?.querySelector('.header');
let lastScrollTop = 0;
let scrollTimeoutId;

if (stickyElm && header) {
  const updateHeader = () => {
    const currentScrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop);
    if (currentScrollTop === lastScrollTop) return;

    clearTimeout(scrollTimeoutId);

    if (currentScrollTop > 80) {
      stickyElm.classList.add('is-pinned');

      if (currentScrollTop < lastScrollTop) {
        body.classList.add('is-fixed');
        header.style.transform = '';
      } else {
        header.style.transform = 'translateY(-200%)';
        scrollTimeoutId = setTimeout(() => {
          body.classList.remove('is-fixed');
        }, 300);
      }
    } else if (currentScrollTop === 0) {
      stickyElm.classList.remove('is-pinned');
      body.classList.remove('is-fixed');
      header.style.transform = '';
    }

    lastScrollTop = currentScrollTop;
  };

  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();
}
